import { PlanCopyConfContextProvider } from "../../context/plan-copy-conf.context";
import PlanCopyConf from "./PlanCopyConf";
import { useLoaderData } from "react-router-dom";

function PlanCopyConfContainer(props) {
	const loaderData = useLoaderData();

	return (
		<PlanCopyConfContextProvider plan={loaderData?.plan}>
			<PlanCopyConf {...props} />
		</PlanCopyConfContextProvider>
	);
}

export default PlanCopyConfContainer;
